import { render, staticRenderFns } from "./PasswordSend.vue?vue&type=template&id=0b09c157&scoped=true&"
import script from "./PasswordSend.vue?vue&type=script&lang=js&"
export * from "./PasswordSend.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSend.vue?vue&type=style&index=0&id=0b09c157&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b09c157",
  null
  
)

export default component.exports